import FieldWrapper from "../../components/FieldWrapper";
import { SingleChoiceFieldType } from "../../types/feedbackFields.types";
import { FieldValueProps } from "../fields.types";
import { withSingleValue } from "../fields.utils";
import Select, { SingleValue } from "react-select";
import "./SelectField.scss";

function ensureValue<T>(value: T | T[] | undefined | null): T | undefined | null {
  if (Array.isArray(value)) return value[0];
  return value;
}

const SelectField = ({
  field,
  value: rawValue,
  error,
  onChange,
}: { field: SingleChoiceFieldType } & FieldValueProps<string>) => {
  const { _id, name, required, choices, selectProps = {} } = field;
  const value = ensureValue(rawValue);
  const id = _id || name;
  const options = [
    ...choices.map((choice) => ({
      value: choice.value || choice.text,
      label: choice.text,
    })),
  ];

  const selectedValue = options.find((o) => o.value === value);
  const onLocalChange = (newValue: SingleValue<{ value: string }>) => {
    onChange(id, newValue?.value);
  };

  return (
    <FieldWrapper field={field} error={error}>
      <div id={id} className="feedback-select">
        <Select
          isClearable
          onChange={onLocalChange}
          required={required}
          options={options}
          value={selectedValue}
          placeholder={false}
          {...selectProps}
        />
      </div>
    </FieldWrapper>
  );
};
export default withSingleValue(SelectField);
